export default ["Image", "Video", "Html", "FixedHtml", "Folder", "Grab", "RSS", "Clock", "Date", "Wayfinder"];
